module.exports = __webpack_public_path__ + "img/img_index_banner_x2@2x.f1e64736.png";